import React, { useMemo, useRef, useState } from 'react';
import Layout from '../../Components/layout/Layout';
import Diagram from '../../Components/Modal/Procedure model component/Diagram';
import Decision from '../../Components/Modal/Procedure model component/Decision';
import Step from '../../Components/Modal/Procedure model component/Step';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { FaStar } from 'react-icons/fa6';
import { FaArrowDownLong } from 'react-icons/fa6';
import { BsFillInfoCircleFill, BsTrash } from 'react-icons/bs';
// import React, { useState } from "react";
// import Decision from "./Procedure model component/Decision";
// import Diagram from "./Procedure model component/Diagram";
// import ProcedurePrev from "./Procedure model component/ProcedurePrev";
// import Step from "./Procedure model component/Step";
import Button from '../../Components/Butten/Button';
// import Pinkbtn from "../Butten/Pinkbtn";
import { useDispatch, useSelector } from 'react-redux';
import {
  CreateProcedureSuccess,
  RequestOfCreatingProcedure,
  CreateProcedureFailed,
} from '../../Redux/ProcedureReducer';
import { api } from '../../Api-Endpoints/apiEndpoint';
import toast from 'react-hot-toast';
import Modal from 'react-modal';
import { useNavigate, useParams } from 'react-router-dom';
import ProcedurePrev from '../../Components/Modal/Procedure model component/ProcedurePrev';
import JoditEditor from 'jodit-react';
import { BsExclamationDiamond } from 'react-icons/bs';
const CreateProcedure = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { isCreating, isCreated, isFailed, procedures, folders } = useSelector(
    state => ({
      procedures: state.Procedure.procedures,
      folders: state.Folder.folders,
    })
  );
  const editor = useRef(null);
  const [procedureName, setProcedureName] = useState('');
  const [infoModal, setInfoModal] = useState(false);
  const [previewModel, setPreviewModel] = useState(false);
  const [setInput, setSetInput] = useState({
    stepName: '',
    decisionName: '',
    stepInfo: '',
    decisionInfo: '',
  });
  const [answerDropDown, setAnswerDropDown] = useState([]);
  const [procedure, setProcedure] = useState({
    procedureName: '',
    isStep: false,
    isDecision: false,
    proc: [],
    images: [],
  });
  const [formData, setFormData] = useState([
    {
      id: `step-${1}`,
      formToggle: true,
      tableOfContent: '',
      information: '',
      decisions: [
        {
          name: '',
          textContent: '',
          link: '',
        },
      ],
      images: [
        {
          name: '',
          src: '',
        },
      ],
      diagrams: [
        {
          name: '',
          src: '',
        },
      ],
    },
  ]);
  const [images, setImages] = useState([]);
  const [diagrams, setDiagrams] = useState([]);
  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: 'Start typings...',
      uploader: {
        url: `${process.env.REACT_APP_ONLINE_URL}/api/v1/get/preSigned/url`,
        isFileAcceptable: file => {
          return true;
        },
      },
      //buttons: 'ul,ol'
    }),
    []
  );
  const handleNewProcInput = e => {
    const { name, value } = e.target;
    const [key1, key2] = name.split('-');
    let newUpdated;

    if (key1 == 'steps') {
      newUpdated = procedure.proc.map((_p, index) =>
        index == procedure.proc.length - 1
          ? {
              ..._p,
              [key1]: {
                ..._p[key1],
                [key2]: value,
                //  stepInfo: _p.steps.stepInfo
              },
            }
          : _p
      );
      setSetInput(prev => ({ ...prev, stepName: value }));
      // setAnswerDropDown((prev)=>([...prev,{icon:'',title:value}]))
    }
    if (key1 == 'decisions') {
      newUpdated = procedure.proc.map((_p, index) =>
        index == procedure.proc.length - 1
          ? {
              ..._p,
              [key1]: {
                ..._p[key1],
                [key2]: value,
                // decisionInfo: _p.decisions.decisionInfo,
              },
            }
          : _p
      );
      setSetInput(prev => ({ ...prev, decisionName: value }));
    }
    // console.log(newUpdated);
    setProcedure({ ...procedure, proc: newUpdated });
    //  }
  };
  const handleProcStepInputInfo = e => {
    const value = e;
    let newUpdated;
    newUpdated = procedure.proc.map((_p, index) =>
      index == procedure.proc.length - 1
        ? { ..._p, steps: { title: _p?.steps?.title, stepInfo: value } }
        : _p
    );
    setSetInput(prev => ({ ...prev, stepInfo: value }));

    // console.log(newUpdated);
    setProcedure({ ...procedure, proc: newUpdated });
  };

  const addNewStep = () => {
    setSetInput({ stepName: '', decisionName: '' });
    setProcedure(prev => ({
      ...prev,
      isStep: true,
      isDecision: false,
      proc: [
        ...prev.proc,
        {
          isStep: true,
          isDecision: false,
          steps: { title: '', stepInfo: '' },
          decisions: {
            title: '',
            decisionInfo: '',
            answer: [{ _ans: '', _associate: '' }],
          },
        },
      ],
    }));
  };

  const addNewDecision = () => {
    setSetInput({ stepName: '', decisionName: '' });
    setProcedure(prev => ({
      ...prev,
      isStep: false,
      isDecision: true,
      proc: [
        ...prev.proc,
        {
          isStep: false,
          isDecision: true,
          steps: {},
          // _answer: [{ _ans: "", _associate: "" }],
          decisions: {
            title: '',
            decisionInfo: '',
            answer: [{ _ans: '', _associate: '' }],
          },
        },
      ],
    }));
    setAnswerDropDown([{ _ans: '', _associate: '' }]);
  };
  const handleProcDecisionInputInfo = e => {
    const value = e;
    console.log(e);
    let newUpdated;
    newUpdated = procedure.proc.map((_p, index) =>
      index == procedure.proc.length - 1
        ? {
            ..._p,
            decisions: {
              ..._p.decisions,
              decisionInfo: value,
              answer: [{ _ans: '', _associate: '' }],
            },
          }
        : _p
    );
    setSetInput(prev => ({ ...prev, decisionInfo: value }));

    setProcedure(prev => ({ ...prev, proc: newUpdated }));
    // console.log(newUpdated)
    // setProcedure({ ...procedure, proc: newUpdated });
  };
  const _onEndProcedure = () => {
    const _lastIndex = procedure.proc.length - 1;
    let updated;
    if (procedure.isDecision) {
      updated = procedure.proc.map((_, index) =>
        index == _lastIndex
          ? { ..._, decisions: { ..._.decisions, answer: [...answerDropDown] } }
          : _
      );
      setProcedure(prev => ({
        ...prev,
        isDecision: false,
        isStep: false,
        proc: updated,
      }));
      return;
    }
    const _updated = {
      ...procedure,
      procedureName,
      isStep: false,
      isDecision: false,
    };
    // console.log(_updated);
    setProcedure(_updated);
  };

  const _onEditProc = index => {
    const _finds = procedure.proc[index];
    // console.log(_finds);
    if (_finds.isStep) {
      setSetInput(prev => ({
        ...prev,
        stepName: _finds.steps.title,
        stepInfo: _finds.steps.stepInfo,
      }));
      const updated = procedure.proc.map((_, _index) =>
        _index == index
          ? { ..._, isStepEdit: true, isDecisionEdit: false }
          : { ..._, isStepEdit: false, isDecisionEdit: false }
      );
      setProcedure({ ...procedure, proc: updated });
    }
    if (_finds.isDecision) {
      setSetInput(prev => ({
        ...prev,
        decisionName: _finds.decisions.title,
        decisionInfo: _finds.decisions.decisionInfo,
      }));
      const updated = procedure.proc.map((_, _index) =>
        _index == index
          ? { ..._, isDecisionEdit: true, isStepEdit: false }
          : { ..._, isStepEdit: false, isDecisionEdit: false }
      );
      setAnswerDropDown([..._finds.decisions.answer]);
      setProcedure({ ...procedure, proc: updated });
    }
  };

  function closeModal() {
    setProcedureName('');
    setFormData([
      {
        id: `step-${1}`,
        formToggle: true,
        tableOfContent: '',
        information: '',
        decisions: [
          {
            name: '',
            textContent: '',
            link: '',
          },
        ],
        images: [
          {
            name: '',
            src: '',
          },
        ],
        diagrams: [
          {
            name: '',
            src: '',
          },
        ],
      },
    ]);
    setInfoModal(false);
  }
  const formToggle = (_index, state) => {
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, formToggle: state } : field
    );
    setFormData(updated);
  };

  const addForm = () => {
    const newField = {
      id: `step-${formData.length + 1}`,
      formToggle: true,
      tableOfContent: '',
      information: '',
      decisions: [
        {
          textContent: '',
          link: '',
        },
      ],
      images: [
        {
          name: '',
          src: '',
        },
      ],
      diagrams: [
        {
          name: '',
          src: '',
        },
      ],
    };
    setFormData(prev => [...prev, newField]);
  };

  const addSubField = _index => {
    const _new = formData.map((f, index) =>
      index === _index
        ? { ...f, decisions: [...f.decisions, { textContent: '', link: '' }] }
        : f
    );
    setFormData(_new);
  };

  const handleInput = (e, id) => {
    const updated = formData.map((field, index) =>
      index === id ? { ...field, [e.target.name]: e.target.value } : field
    );
    setFormData(updated);
    // console.log(updated);
  };
  const handleEditor = (e, index) => {
    const updated = formData.map((field, _index) =>
      _index === index ? { ...field, information: e } : field
    );
    setFormData(updated);
  };
  const handleInsideInput = (e, __index, index2) => {
    const _target = formData.find((f, index) => index === __index);
    const _updated = _target.decisions.map((p, _index) =>
      _index === index2 ? { ...p, [e.target.name]: e.target.value } : p
    );
    _target.decisions = _updated;
    const __updated = formData.map((d, i) =>
      i === __index ? { ...d, decisions: [..._target.decisions] } : d
    );
    setFormData(__updated);
  };
  const uploadImages = id => {
    const imgWindow = document.querySelector(`#${id}`);
    imgWindow.click();
  };
  const _saveImages = e => {
    const file = e.target.files;
    let _files = [];
    for (const key in Array.from(file)) {
      _files.push({
        name: file[key].name,
        src: URL.createObjectURL(file[key]),
      });
    }
    setImages([..._files]);
    setProcedure(prev => ({ ...prev, images: _files }));
  };
  const saveImages = (e, _index, _id) => {
    const file = e.target.files;
    let _files = [];
    for (const key in Array.from(file)) {
      _files.push({
        name: file[key].name,
        src: URL.createObjectURL(file[key]),
      });
      setImages(prev => [...prev, file[key]]);
    }
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, images: _files } : field
    );
    setFormData(updated);
  };

  const saveDiagrams = (e, _index, _id) => {
    const file = e.target.files;
    let _files = [];
    for (const key in Array.from(file)) {
      _files.push({
        name: file[key].name,
        src: URL.createObjectURL(file[key]),
      });
      setDiagrams(prev => [...prev, file[key]]);
    }
    const updated = formData.map((field, index) =>
      index === _index ? { ...field, diagrams: _files } : field
    );
    setFormData(updated);
  };
  const deleteStep = _index => {
    if (formData.length !== 1) {
      const updated = formData.filter((field, index) => index !== _index);
      setFormData(updated);
    }
  };
  const onDeleteImage = (stepIndex, imgIndex) => {
    const step = formData.find((field, index) => index === stepIndex);
    const _images = step.images.filter((_img, index) => index !== imgIndex);
    step.images = _images;
    const _updatedStep = formData.map((field, index) =>
      index === stepIndex ? { ...field, images: [...step.images] } : field
    );
    setFormData(_updatedStep);
  };
  const onDeleteDiagrams = (stepIndex, diaIndex) => {
    const step = formData.find((field, index) => index === stepIndex);
    const _diagram = step.diagrams.filter((_dia, index) => index !== diaIndex);
    step.diagrams = _diagram;
    const _updatedStep = formData.map((field, index) =>
      index === stepIndex ? { ...field, diagrams: [...step.diagrams] } : field
    );
    setFormData(_updatedStep);
  };
  const submit = async () => {
    try {
      const _formData = new FormData();
      _formData.append('name', procedureName);
      _formData.append('folderId', params?.id);
      images.forEach(_img => {
        _formData.append('images', _img);
      });
      const __procedure = procedure.proc.map((_, index) => {
        if (_.isStep) {
          return {
            steps: _.steps,
          };
        }
        if (_.isDecision) {
          return {
            decisions: _.decisions,
          };
        }
      });
      //  console.log(__procedure)
      _formData.append('formData', JSON.stringify(__procedure));
      dispatch(RequestOfCreatingProcedure());
      const { status, data } = await api.post(
        '/procedure/procedure-create',
        _formData
      );
      if (status === 201) {
        toast.success('Procedure Created Successfully');
        closeModal();
        dispatch(CreateProcedureSuccess(data.procedure));
        setInfoModal(true);
      }
    } catch (error) {
      closeModal();
      dispatch(CreateProcedureFailed());
      console.log(error.message);
    }
  };

  const _onGetAnswer = (e, index) => {
    const { name, value } = e.target;
    const updated = answerDropDown.map((_, _index) =>
      _index == index ? { ..._, [name]: value } : _
    );
    // console.log(updated)
    setAnswerDropDown(updated);
  };
  const _onGetAnswerByEdit = (e, index, __ans_index) => {
    const { name, value } = e.target;
    let _finds = procedure.proc[index];
    const _updated = _finds.decisions.answer.map((_, _index) =>
      _index == __ans_index ? { ..._, [name]: value } : _
    );

    const updated = procedure.proc.map((_, _index) =>
      _index == index
        ? { ..._, decisions: { ..._.decisions, answer: _updated } }
        : _
    );
    // _finds.decisions.answer=_updated;
    setProcedure(prev => ({ ...prev, proc: updated }));
  };

  const _onGetAssociate = (e, index) => {
    const { name, value } = e.target;
    const [type, ...rest] = value.split('-');
    const _value = rest.join('-');
    const updated = answerDropDown.map((_, _index) =>
      _index == index ? { ..._, [name]: _value, type: type } : _
    );
    setAnswerDropDown(updated);
  };
  const _onGetAssociateByEdit = (e, index, __associate_index) => {
    const { name, value } = e.target;
    const [type, ...rest] = value.split('-');
    const _value = rest.join('-');
    let _finds = procedure.proc[index];
    const _updated = _finds.decisions.answer.map((_, _index) =>
      _index == __associate_index ? { ..._, [name]: _value, type: type } : _
    );

    const updated = procedure.proc.map((_, _index) =>
      _index == index
        ? { ..._, decisions: { ..._.decisions, answer: _updated } }
        : _
    );
    // _finds.decisions.answer=_updated;
    setProcedure(prev => ({ ...prev, proc: updated }));
  };
  const _onFinishEdit = index => {
    const _finds = procedure.proc[index];
    // console.log(_finds);
    if (_finds.isStep) {
      const updated = procedure.proc.map((_, _index) =>
        _index == index ? { ..._, isStepEdit: false, isDecisionEdit: false } : _
      );
      setProcedure({ ...procedure, proc: updated });
    }
    if (_finds.isDecision) {
      // const _intercept=answerDropDown.filter(item=>!_finds.decisions.answer.includes(item));
      // console.log(_intercept,answerDropDown)
      const updated = procedure.proc.map((_, _index) =>
        _index == index ? { ..._, isDecisionEdit: false, isStepEdit: false } : _
      );
      setProcedure({ ...procedure, proc: updated });
    }
  };
  const _onEditStepAndSave = (e, index) => {
    const { name, value } = e.target;
    const [key1, key2] = name.split('-');
    let newUpdated;
    console.log(key1, key2);
    if (key1 == 'steps') {
      newUpdated = procedure.proc.map((_p, _index) =>
        _index == index
          ? {
              ..._p,
              [key1]: {
                ..._p[key1],
                [key2]: value,
                //  stepInfo: _p.steps.stepInfo
              },
            }
          : _p
      );
      setSetInput(prev => ({ ...prev, stepName: value }));
      // setAnswerDropDown((prev)=>([...prev,{icon:'',title:value}]))
    }
    if (key1 == 'decisions') {
      newUpdated = procedure.proc.map((_p, _index) =>
        _index == index
          ? {
              ..._p,
              [key1]: {
                ..._p[key1],
                [key2]: value,
                // decisionInfo: _p.decisions.decisionInfo,
              },
            }
          : _p
      );
      setSetInput(prev => ({ ...prev, decisionName: value }));
    }
    // console.log(newUpdated);
    setProcedure({ ...procedure, proc: newUpdated });
    //  }
  };
  const _onEditStepInfoAndSave = (e, index) => {
    const _finds = procedure.proc[index];
    const value = e;
    let newUpdated;
    if (_finds.isStep) {
      newUpdated = procedure.proc.map((_p, _index) =>
        _index == index
          ? { ..._p, steps: { ..._p.steps, stepInfo: value } }
          : _p
      );
      setSetInput(prev => ({ ...prev, stepInfo: value }));
    }
    if (_finds.isDecision) {
      newUpdated = procedure.proc.map((_p, _index) =>
        _index == index
          ? { ..._p, decisions: { ..._p.decisions, decisionInfo: value } }
          : _p
      );
      setSetInput(prev => ({ ...prev, decisionInfo: value }));
    }

    // console.log(newUpdated);
    setProcedure({ ...procedure, proc: newUpdated });
  };
  const _onAddMoreAnswer = index => {
    const updated = procedure.proc.map((_, _index) =>
      _index == index
        ? {
            ..._,
            decisions: {
              ..._.decisions,
              answer: [..._.decisions.answer, { _ans: '', _associate: '' }],
            },
          }
        : _
    );
    setProcedure(prev => ({ ...prev, proc: updated }));
  };
  return (
    <Layout heading={'Create Procedure'}>
      <div className="w-[100%]">
        <div className="procedure-info-prev flex flex-col m-2 h-[20vh] ">
          <p className="text-xl font-medium">Procedure Information:</p>
          <div className="flex w-[100%] ">
            <div className="flex flex-col w-[50%]">
              <label>Procedure Name:*</label>
              <input
                required
                type="text"
                placeholder="Enter Procedure Name"
                className="w-[70%] p-2 border focus:border-slate-600 rounded-md outline-none"
                name={'procedureName'}
                value={procedureName}
                onChange={e => setProcedureName(e.target.value)}
              />
              <div className="h-["></div>
            </div>
            <div className="flex justify-start items-center gap-5 w-[50%] ">
              <button
                onClick={addNewStep}
                className="h-[3dvh] self-end w-[7dvw] bg-[#ffffff]  border border-[#fe104d]
              rounded-md"
              >
                Add Step
              </button>
              <button
                onClick={addNewDecision}
                className="h-[3dvh] self-end w-[7dvw] bg-[#ffffff]  border border-[#fe104d]
             rounded-md"
              >
                Add Decision
              </button>
              <button
                onClick={_onEndProcedure}
                className="h-[3dvh] self-end w-[7dvw] bg-[#ffffff]  border border-[#fe104d]
             rounded-md"
              >
                End Step
              </button>
            </div>
            {/* <h1 className="text-2xl font-semibold">Create Procedure</h1> */}
            {/* <button onClick={closeModal}>
              <IoMdCloseCircleOutline size={20} />
            </button> */}
          </div>
          <div className="h-[10dvh] w-[100%] flex justify-start items-center gap-5 ">
            {/* <div className="upload-btn  flex justify-between w-[30vw] "> */}
            <p style={{ color: '#eceff4' }}>.</p>
            <input
              type="file"
              id={`images-${1}`}
              onChange={e => _saveImages(e)}
              hidden
              multiple
            />
            <button
              onClick={() => uploadImages(`images-${1}`)}
              className="border-2 bg-white rounded-md p-1 text-xs
                            "
            >
              Upload Images
            </button>
            <div className="w-[50%] h-[10dvh] overflow-auto">
              <table className="w-[100%] table-auto border-collapse border border-gray-300 ">
                <thead className="bg-gray-200">
                  <tr>
                    <th className=" border border-gray-300">Name</th>
                    <th className="px-4 py-2 bg-gray-200 border border-gray-300">
                      Image
                    </th>
                    <th className="px-4 py-2 bg-gray-200 border border-gray-300">
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {procedure.images.map((_, index) => (
                    <>
                      <tr>
                        <td className="px-4 py-2 border border-gray-300 text-center">
                          {_?.name?.substr(0, 20)}
                        </td>
                        <td className="px-4 py-2 border border-gray-300 text-center">
                          <div className="m-auto h-[50px] w-[50px] border border-black">
                            <img src={_?.src} className="h-[100%] w-[100%]" />
                          </div>
                        </td>
                        <td className="px-4 py-2 border border-gray-300 flex justify-center items-center">
                          <button
                            onClick={() =>
                              setProcedure(prev => ({
                                ...prev,
                                images: prev.images.filter(
                                  (__, _index) => _index != index
                                ),
                              }))
                            }
                          >
                            <BsTrash color="#fe104d" />
                          </button>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>

            {/* </div> */}
          </div>
        </div>

        <hr />
        <div className="procedure-info-prev flex m-2 h-[60vh] ">
          <div className="procedure-info-heading w-[100vw] h-[58vh] p-2 overflow-auto border border-slate-500">
            <div className="procinfo-main">
              {/* copied from here */}
              <div className=" w-[100%] flex gap-5 flex-col ">
                {procedure.proc.map((_proc, index) =>
                  _proc?.isStep ? (
                    <div className="border border-b-violet-400">
                      <div
                        onClick={() => _onEditProc(index)}
                        className="w-[100%] cursor-pointer flex flex-col justify-start gap-5"
                      >
                        <h1 className="flex gap-5 ml-5">
                          <span className="h-[30px] w-[30px] bg-black rounded-[50%] text-white flex justify-center items-center">
                            {index + 1}
                          </span>
                          {_proc?.steps?.title}
                        </h1>
                        <h4
                          className="self-start"
                          dangerouslySetInnerHTML={{
                            __html: _proc.steps.stepInfo,
                          }}
                        ></h4>
                      </div>
                      {_proc.isStepEdit && (
                        <div>
                          <input
                            type={'text'}
                            className=" w-[50%]"
                            name={'steps-title'}
                            value={setInput.stepName}
                            onChange={e => _onEditStepAndSave(e, index)}
                            placeholder="Enter Step Name"
                          />
                          <JoditEditor
                            ref={editor}
                            // onBlur={newContent => setContent(newContent)}
                            config={config}
                            // name={'steps'}
                            value={setInput.stepInfo}
                            onChange={e => _onEditStepInfoAndSave(e, index)}
                          />
                          <button
                            className="h-[30px] w-[20dvw] border border-black bg-white"
                            onClick={() => _onFinishEdit(index)}
                          >
                            Finish
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="border border-b-violet-400">
                      <div
                        onClick={() => _onEditProc(index)}
                        className="w-[100%] flex cursor-pointer flex-col justify-start gap-5"
                      >
                        <h1 className="flex gap-5 ml-5">
                          <label className="flex">
                            {index + 1}
                            <BsExclamationDiamond size={30} />
                          </label>
                          {/* <span className="h-[30px] w-[30px] bg-black rounded-[50%] text-white flex justify-center items-center">
                            {index + 1}
                          </span> */}
                          {_proc?.decisions?.title}
                        </h1>
                        <h4
                          className="self-start"
                          dangerouslySetInnerHTML={{
                            __html: _proc?.decisions.decisionInfo,
                          }}
                        ></h4>
                      </div>
                      <h1 className="text uppercase">Answers</h1>
                      <div className="w-[30dvw] h-[50%] flex flex-col border border-black">
                        {_proc?.decisions?.answer?.map((_, index) => (
                          <div
                            className="h-[10%] w-[100%] flex justify-around items-center border border-black"
                            key={index}
                          >
                            <h2>
                              <label className="h-[10px] w-[10px] rounded-[50%] border border-slate-400 bg-white"></label>{' '}
                              {_?._ans}
                            </h2>
                            {_?.type == 'steps' ? (
                              <span className="h-[20px] w-[20px] bg-black rounded-[50%] text-white flex justify-center items-center">
                                {index + 1}
                              </span>
                            ) : (
                              <label className="flex">
                                {index + 1}
                                <BsExclamationDiamond size={20} />
                              </label>
                            )}
                          </div>
                        ))}
                      </div>
                      {_proc.isDecisionEdit && (
                        <div>
                          <input
                            type={'text'}
                            className=" w-[50%]"
                            name={'decisions-title'}
                            value={setInput.decisionName}
                            onChange={e => _onEditStepAndSave(e, index)}
                            placeholder="Enter Decision Name"
                          />
                          <JoditEditor
                            ref={editor}
                            // onBlur={newContent => setContent(newContent)}
                            config={config}
                            // name={'decisions'}
                            value={setInput.decisionInfo}
                            onChange={e => _onEditStepInfoAndSave(e, index)}
                          />
                          <div className="flex flex-col">
                            {_proc?.decisions.answer.map((__, _index) => (
                              <>
                                <input
                                  className="w-[50%]"
                                  type={'text'}
                                  placeholder="Write answer..."
                                  value={__?._ans}
                                  onChange={e =>
                                    _onGetAnswerByEdit(e, index, _index)
                                  }
                                  name="_ans"
                                />
                                <select
                                  onChange={e =>
                                    _onGetAssociateByEdit(e, index, _index)
                                  }
                                  value={__?._associate}
                                  className="w-[50%]"
                                  name="_associate"
                                  id=""
                                >
                                  {procedure.proc.map((_, index) => (
                                    <>
                                      <option
                                        value={`steps-${_?.steps?.title}`}
                                      >
                                        {_?.steps?.title}
                                      </option>
                                      <option value={_?.decisions?.title}>
                                        {_?.decisions?.title}
                                      </option>
                                    </>
                                  ))}
                                </select>
                              </>
                            ))}
                            {/* {answerDropDown.map((__, _index) => (
                      <>
                        <input
                          className="w-[50%]"
                          type={"text"}
                          placeholder="Write answer..."
                          value={__?._ans}
                          onChange={(e) => _onGetAnswerByEdit(e,index, _index)}
                          name="_ans"
                        />
                        <select
                          onChange={(e) => _onGetAssociate(e, _index)}
                          value={__?._associate}
                          className="w-[50%]"
                          name="_associate"
                          id=""
                        >
                          {procedure.proc.map((_, index) => (
                            <>
                              <option value={`steps-${_?.steps?.title}`}>
                                {_?.steps?.title}
                              </option>
                              <option value={_?.decisions?.title}>
                                {_?.decisions?.title}
                              </option>
                            </>
                          ))}
                        </select>
                      </>
                    ))} */}
                            <button
                              // onClick={_addAnswer}
                              onClick={() => _onAddMoreAnswer(index)}
                            >
                              Add more answer
                            </button>
                          </div>
                          <button
                            className="h-[30px] w-[20dvw] border border-black bg-white"
                            onClick={() => _onFinishEdit(index)}
                          >
                            Finish
                          </button>
                        </div>
                      )}
                    </div>
                  )
                )}
                {procedure.isStep && (
                  <>
                    <input
                      type={'text'}
                      className=" w-[50%]"
                      name={'steps-title'}
                      value={setInput.stepName}
                      onChange={handleNewProcInput}
                      placeholder="Enter Step Name"
                    />
                    <JoditEditor
                      ref={editor}
                      // onBlur={newContent => setContent(newContent)}
                      config={config}
                      // name={'steps'}
                      value={setInput.stepInfo}
                      onChange={handleProcStepInputInfo}
                    />
                  </>
                )}
                {procedure.isDecision && (
                  <>
                    <input
                      type={'text'}
                      className=" w-[50%]"
                      name={'decisions-title'}
                      value={setInput.decisionName}
                      onChange={handleNewProcInput}
                      placeholder="Enter Decision Name"
                    />
                    <JoditEditor
                      ref={editor}
                      // onBlur={newContent => setContent(newContent)}
                      config={config}
                      // name={'decisions'}
                      value={setInput.decisionInfo}
                      onChange={handleProcDecisionInputInfo}
                    />
                    {answerDropDown.map((__, _index) => (
                      <>
                        <input
                          className="w-[50%]"
                          type={'text'}
                          placeholder="Write answer..."
                          onChange={e => _onGetAnswer(e, _index)}
                          name="_ans"
                        />
                        <select
                          onChange={e => _onGetAssociate(e, _index)}
                          className="w-[50%]"
                          name="_associate"
                          id=""
                        >
                          {procedure.proc.map((_, index) => (
                            <>
                              <option value={`steps-${_?.steps?.title}`}>
                                {_?.steps?.title}
                              </option>
                              <option value={_?.decisions?.title}>
                                {_?.decisions?.title}
                              </option>
                            </>
                          ))}
                        </select>
                      </>
                    ))}
                    <button
                      // onClick={_addAnswer}
                      onClick={() =>
                        setAnswerDropDown(prev => [
                          ...prev,
                          { _ans: '', _associate: '' },
                        ])
                      }
                    >
                      Add more answer
                    </button>
                  </>
                )}
              </div>
              {/* second box  of desicion */}

              {/* 3rd box */}
            </div>
          </div>
        </div>
        <div className="submit-btn flex justify-between w-[80vw]">
          {/* <div className="dot bg-white">.</div> */}
          <div className="btn flex justify-start items-center gap-3">
            {/* <Button btntext="cancle" /> */}
            <button
              className="h-[30px] w-[100px] ml-5 bg-[#fe104d] 
              border border-[#fe104d]
               focus:outline 
               focus:transition-all
                outline-[#fe104d] 
                text-white 
                text-center 
                cursor-pointer
                rounded-md 
                "
              onClick={submit}
            >
              Save
            </button>
            <button
              onClick={() => setPreviewModel(true)}
              className="h-[30px] w-[100px]
             border
              border-[#fe104d]
               text-black 
               text-center
                cursor-pointer 
                focus:outline 
                focus:transition-all
                 outline-[#fe104d]
                 rounded-md
                 "
            >
              Preview
            </button>
            {/* <Pinkbtn pbtntext="save" /> */}
          </div>
        </div>
      </div>

      <Modal
        isOpen={infoModal}
        style={{
          content: {
            height: '20vh',
            width: '20vw',
            transform: 'translate(200%,170%)',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }}
      >
        <div className="h-[20vh] w-[20vw] flex flex-col justify-center items-center gap-3">
          <div className="flex justify-center items-center gap-1">
            <BsFillInfoCircleFill color="#fe104d" size={'25px'} />
            <h3>Do you want to add more</h3>
          </div>
          <div className="flex gap-1">
            <button
              className="border border-black outline-none flex justify-center items-center h-[30px] w-[100px] rounded-md cursor-pointer"
              onClick={() => navigate('/procedures')}
            >
              No
            </button>
            <button
              onClick={closeModal}
              className="border border-black outline-none flex justify-center items-center h-[30px] w-[100px] bg-[#fe104d] rounded-md cursor-pointer text-white"
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={previewModel}
        onRequestClose={() => setPreviewModel(false)}
        style={{
          content: {
            height: '80vh',
            width: '85vw',
            transform: 'translate(10%,10%)',
            // overflow: "hidden",
            overflow: 'overFlowY',
            overFlowX: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }}
      >
        <div className="h-[100%] w-[100%] flex flex-col">
          <div className="h-[5vh] w-[100%] flex justify-end">
            <button
              onClick={() => setPreviewModel(false)}
              className="h-[30px] w-[100px] ml-5 bg-[#fe104d] 
           border border-[#fe104d]
            focus:outline 
            focus:transition-all
             outline-[#fe104d] 
             text-white 
             text-center 
             cursor-pointer
             rounded-md 
             "
            >
              Close
            </button>
          </div>
          <ProcedurePrev formData={formData} />
        </div>
      </Modal>
    </Layout>
  );
};

export default CreateProcedure;
